export const incomeSum = (incomes: { amount: number }[]) => {
  return incomes.reduce((result, income) => result + income.amount, 0)
}